import React from 'react';
import PropTypes from 'prop-types';
import { IconName, IconFill } from './iconStorage';

function Icon(props) {
  const {
    name,
    fillRule = 'evenodd',
    colorFill = 'enabled',
    stroke = '',
    height = 24,
    width = 24,
    strokeWidth = '',
    viewBox = '0 0 24 24'
  } = props;
  const iconPath = IconName(name);
  const fill = IconFill(colorFill) || colorFill;
  return (
    <svg width={`${width}px`} height={`${height}px`} viewBox={viewBox}>
      <path stroke={stroke} fillRule={fillRule} strokeWidth={strokeWidth} fill={fill} d={iconPath} />
    </svg>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired
};

export { Icon };
